import React, { Component } from "react"
import PropTypes from 'prop-types';
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { logoutUser } from "../../store/actions"
import { changeFirstLoadToFalse } from './../../store/firstLoad/actions';

class Logout extends Component {
  /**
   * Redirect to login
   */
  componentDidMount = () => {
    // emit the event
    this.props.changeFirstLoadToFalse()
    this.props.logoutUser(this.props.history)
  }

  render() {
    return <React.Fragment></React.Fragment>
  }
}

Logout.propTypes = {
  history: PropTypes.any,
  logoutUser: PropTypes.func,
  changeFirstLoadToFalse: PropTypes.func
}

export default withRouter(connect(null, { logoutUser,changeFirstLoadToFalse })(Logout))
